import React from 'react';
import './SubscriptionButton.css';
import connectIcon from '../images/icons/icon_connect.png';
import { triggerHaptic } from '../services/telegram';

function SubscriptionButton({ onOpenSubscribe, isPrimary = false }) {
  const buttonLabel = 'Купить подписку';

  const handleClick = () => {
    triggerHaptic();
    onOpenSubscribe?.();
  };

  return (
    <button className={`subscription-button${isPrimary ? ' subscription-button-primary' : ''}`} onClick={handleClick}>
      <img src={connectIcon} alt="" className="button-icon" />
      <span className="button-text">{buttonLabel}</span>
      <span className="button-price">от 147 Р</span>
    </button>
  );
}

export default SubscriptionButton;

